import React from 'react';
import ButtonGroup from '@components/button-group';
import * as styles from './FilterDirection.scss';

const FilterDirection = (props) => {
  const {
    options,
    selectedOrder,
    handleReverseChange,
  } = props;

  return (
    <ButtonGroup
      className={styles.direction}
      options={options}
      value={selectedOrder}
      onChange={handleReverseChange}
      data-qa="ati-ui-button-group-qa"
    />
  );
};

export default FilterDirection;
